import React, { useEffect, useState } from "react";
import { PlusCircle } from "react-feather";
import { Link } from "react-router-dom";
import { Edit, Eye, Trash2 } from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "antd";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import AddCustomerModal from "../../core/modals/customers/addCustomerModal";
import UpdateCustomerModal from "../../core/modals/customers/updateCustomerModal";
import {set_supplier_edit, set_page_refresh} from "../../core/redux/action";
// import { dateFormatter } from "../../plugins/helper";
import { APIgetPublicUsers, deletePublicUser } from "../../api/settings.ts";

const ManageCustomers = () => {
  const dispatch = useDispatch();
  const [customers, setCustomers] = useState([]);
  const [allCustomers, setAllCustomers] = useState([]);
  
  const [searchTerm, setSearchTerm] = useState("");
  const l = useSelector((state) => state.language || "en");
  const t = useSelector((state) => state.translation || "en");
  // const data = useSelector((state) => state.supplier_list);
  const pageRefresh = useSelector((state) => (state.pageRefresh?.suppliers || 0));
  // const dropdownList = useSelector((state) => state.dropdowns_list || []);
  // const countryOptions = dropdownList.filter((itm) => itm.identifier == "countries") 
  useEffect(() => {
    async function fetchData() {
      try {
          //  setLoading(true)
            const res = await APIgetPublicUsers({});
               console.log("custDatares",res?.response);
            if (res?.response) {
           
              const userData = res?.response.reverse();
              const custData = userData.map((item) => {
                const { fullName, firstName, lastName, phoneNumber } = item.profile;
                return {
                  ...item,
                  fullName: !fullName ? firstName +" "+(lastName?lastName:"") : fullName,
                  firstName,
                  lastName,
                  phoneNumber
                };
              });
                console.log("custData",custData);
              setAllCustomers(custData);
              setCustomers(custData);
              // setLoading(false)
            }
          } catch (error) {
            // setLoading(false)
            console.log(error);
          }
    }
    fetchData()
  }, [pageRefresh])

  useEffect(() => {
      let filteredCustomers = [...allCustomers]; 
      
      if (searchTerm && searchTerm !== "") {
      filteredCustomers = filteredCustomers.filter((customer) => {
        // If searchTerm is not a number, filter by name, category, and other conditions
        return (
          customer.fullName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          customer.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          customer.phoneNumber?.includes(searchTerm.toLowerCase()) ||
          customer.shippingAddress?.city?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          customer.shippingAddress?.country?.toLowerCase().includes(searchTerm.toLowerCase())
        );
      });
    }
      setCustomers(filteredCustomers);
    }, [searchTerm]);

  const columns = [
   
    {
      title: t?.[l]?.["customer_name"] || "Customer Name",
      dataIndex: "fullName",
      // sorter: (a, b) => a.name.length - b.name.length,
    },
    

    {
      title: t?.[l]?.["email"] || "Email",
      dataIndex: "email",
      // sorter: (a, b) => a.email.length - b.email.length,
    },

    {
      title: t?.[l]?.["phone"] || "Phone",
      dataIndex: "phoneNumber",
      // sorter: (a, b) => a.contactNo.length - b.contactNo.length,
    },
    {
      title: t?.[l]?.["city"] || "City",
       dataIndex: ["shippingAddress", "city"],

    },

    {
      title: t?.[l]?.["country"] || "Country",
      dataIndex: ["shippingAddress","country"],
      render: (text) => {
        if(text != "")
        return <span className="">{t?.[l]?.[text?.toLowerCase()] || text}</span>;
      }
    },
    {
      title: t?.[l]?.["action"] || "Action",
      dataIndex: "action",
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <div className="input-block add-lists"></div>

            <Link className="me-2 p-2 hidden" to="#">
              <Eye className="feather-view" />
            </Link>
            {canUpdate && (
              <Link
                className="me-2 p-2"
                to="#"
                data-bs-toggle="modal"
                data-bs-target="#edit-units"
                onClick={() => {
                  dispatch(set_supplier_edit(record));
                }}
              >
                <Edit className="feather-edit" />
              </Link>
            )}
            {canDelete && (
              <Link
                className="confirm-text p-2"
                to="#"
                onClick={(e) => {showConfirmationAlert(e,record)}}
              >
                <Trash2 className="feather-trash-2" />
              </Link>
            )}
          </div>
        </div>
      ),
      // sorter: (a, b) => a.createdby.length - b.createdby.length,
    },
  ];

  const MySwal = withReactContent(Swal);

  const showConfirmationAlert = (e,record) => {
    e.preventDefault();
    MySwal.fire({
      title: t?.[l]?.["are_you_sure?"] || "Are you sure?",
      text: t?.[l]?.["you_won't_be_able_to_revert_this!"] || "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: t?.[l]?.["yes,_delete_it!"] || "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: t?.[l]?.["cancel"] || "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
           const result = await deletePublicUser({ id: record._id});
          //           if (res) {
          // let result = await axios.post("removesupplier/", record);
          dispatch(set_page_refresh("suppliers"));
          console.log(result)
          MySwal.fire({
            title: t?.[l]?.["deleted!"] || "Deleted!",
            text: t?.[l]?.["item_has_been_deleted."] || "Item has been deleted.",
            className: "btn btn-success",
            confirmButtonText: t?.[l]?.["ok"] || "OK",
            customClass: {
              confirmButton: "btn btn-success",
            },
          }).then(() => {
          });
        } catch(e) {
          console.log(e)
          return false;
        }
        
      } else {
        MySwal.close();
      }
    });
  };
  
  //Permissions
  const permissions = useSelector(state => state.permissions) || [];
  const roleTitle = useSelector(state => state.roleTitle) || [];
  const roleTitleAdmin = useSelector(state => state.roleTitleAdmin) || [];
  
  // Check permissions
  const canView = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'suppliers' && p.Permission.toLowerCase() === 'view');
  const canCreate = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'suppliers' && p.Permission.toLowerCase() === 'create');
  const canUpdate = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'suppliers' && p.Permission.toLowerCase() === 'update');
  const canDelete = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'suppliers' && p.Permission.toLowerCase() === 'delete');

  if (!canView) {
      return ( 
      <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}><div className="content"><p>{t?.[l]?.["no_permission"] || "You do not have permission to view this page."}</p></div></div>
  )}

  return (
    <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}>
      <div className="content">
       <div className="page-header">
                <div className="add-item d-flex">
                  <div className="page-title">
                    <h4>{t?.[l]?.["customer_list"] || "Customer List"}</h4>
                    <h6>{t?.[l]?.["manage_your_customers"] || "Manage your customers"}</h6>
                  </div>
                </div>
                {/* reports */}
                
                <div className="search-set" style={{marginLeft: "auto"}}>
                  <div className="search-input">
                    <input
                      type="text"
                      placeholder={t?.[l]?.["search"] || "Search"}
                      className="form-control"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <span to="#" className="btn btn-searchset" style={{ paddingTop: "10px"}}>
                      <i className="feather-search" />
                    </span>
                  </div>
      
                    </div>
                {canCreate ? (
                  <div className="page-btn" onClick={() => dispatch(set_supplier_edit({}))}>
                      <Link
                                 to="#"
                                 className="btn btn-added"
                                 data-bs-toggle="modal"
                                 data-bs-target="#add-units"
                               >
                                 <PlusCircle className="me-2" />
                                 {t?.[l]?.["add_new_customer"] || "Add New Customer"}
                               </Link>
                  </div>
                 ) : null}
                
              </div>
        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-responsive">
              <Table
                className="table datanew"
                columns={columns}
                dataSource={customers}
                rowKey={(record) => record._id}
              />
            </div>
          </div>
        </div>
      </div>

      {/* <AddCustomerModal countries={countryOptions} />
      <UpdateCustomerModal countries={countryOptions} /> */}
       <AddCustomerModal />
      <UpdateCustomerModal />
    </div>
  );
};

export default ManageCustomers;
